import axios from 'axios';

export function getDocumentation(subscriberId) {
    return axios.get(`/ma_documentations/` + subscriberId, {
        params: {},
    });
}

export function getDocument(id, link) {
    return axios.get(`/ma_documentations/${id}/${link}`, {
        params: {},
    });
}
